var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-textarea', {
    staticClass: "tags-text__textarea",
    attrs: {
      "flat": "",
      "solo": "",
      "auto-grow": "",
      "rows": "8",
      "hide-details": ""
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('v-divider'), _c('v-row', {
    staticClass: "pa-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "tile": "",
      "depressed": "",
      "color": "error",
      "outlined": ""
    },
    on: {
      "click": _vm.sync
    }
  }, [_vm._v(" 취소하기 ")])], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "tile": "",
      "depressed": "",
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.emit
    }
  }, [_vm._v(" 적용하기 ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }